// Copyright (c) 2025 Bytedance Ltd. and/or its affiliates
// SPDX-License-Identifier: MIT

"use client";

import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";

import { ThemeProvider } from "~/components/theme-provider";

export function ThemeProviderWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();
  const isChatPage = pathname?.startsWith("/chat");
  const [iframeTheme, setIframeTheme] = useState<string | null>(null);
  // 检查是否在iframe中，并获取主题参数
  useEffect(() => {
    try {
      // 检查是否在iframe中
      const isInIframe = window !== window.top;
      
      if (isInIframe) {
        // 获取URL参数
        const params = new URLSearchParams(window.location.search);
        const theme = params.get('theme');
        if (theme && ['light', 'dark', 'system'].includes(theme)) {
          setIframeTheme(theme);
          window.localStorage.setItem('theme', theme);
        }
      }
    } catch (e) {
      console.error('Error checking iframe status:', e);
    }
  }, []);

  // 确定最终主题
  const finalTheme = iframeTheme || (isChatPage ? undefined : "dark");
  return (
    <ThemeProvider
      attribute="class"
      defaultTheme={"dark"}
      enableSystem={isChatPage}
      forcedTheme={finalTheme}
      disableTransitionOnChange
    >
      {children}
    </ThemeProvider>
  );
}
